import project1_img from '../images/canva.png';
import project2_img from '../images/safarirally.png';
import project3_img from '../images/arsenal.png';
import project5_img from '../images/project5.jpg';
import ecommerce_video from '../images/recording.mp4';


const mywork_data = [
  {
    w_no: 1,
    w_name: "Poster",
    w_img: project1_img,
    type: "image"
  },
  {
    w_no: 2,
    w_name: "Poster",
    w_img: project2_img,
    type: "image"
  },
  {
    w_no: 3,
    w_name: "E-commerce Poster",
    w_img: project3_img,
    type: "image"
  },
  {
  w_no: 6,
  w_name: "Portfolio Website",
  w_vid: ecommerce_video,
  type: "video"
},
  {
    w_no: 5,
    w_name: "Business Poster",
    w_img: project5_img,
    type: "image"
  },
  {
    w_no: 6,
    w_name: "E-commerce Website",
    w_vid: "https://res.cloudinary.com/dfdqp6bdl/video/upload/v1743411724/emwus5fcywjeyropdn5w.mp4",
    type: "video"
  }
];

export default mywork_data;
